var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var InputLabel = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 1.2rem;\n  font-weight: 500;\n  letter-spacing: 1.2px;\n  line-height: 1.3em;\n  text-transform: uppercase;\n  & .req-mark {\n    color: ", ";\n    font-weight: 600;\n  }\n\n  &.small {\n    font-size: 1rem;\n  }\n"], ["\n  color: ", ";\n  font-size: 1.2rem;\n  font-weight: 500;\n  letter-spacing: 1.2px;\n  line-height: 1.3em;\n  text-transform: uppercase;\n  & .req-mark {\n    color: ", ";\n    font-weight: 600;\n  }\n\n  &.small {\n    font-size: 1rem;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.generalContent.text.alt.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.error;
});
var templateObject_1;
//# sourceMappingURL=InputLabel.js.map